/**
 * Helper function to convert an object of type T|T[] to an array.
 *
 * @tparam      {T}       The object type
 * @param array {T|T[]}   Either an object or array of objects
 * @returns     {T[]}     The paramater converted to an array
 */
export function toArray<T>(array: T | T[]): T[] {
  array = array || [];
  array = array instanceof Array ? array : [array];

  return array.filter((t: T) => !!t);
}
